import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '@store/states/app.state';

const appSelector = createFeatureSelector<AppState>('app');

export const appSelectors = {
  generalLoading: createSelector(appSelector, (state) => state.showLoading),
  specificLoading: createSelector(appSelector, (state) => state.specificLoading),
  visitedHeaderNotifications: createSelector(appSelector, (state) => state.visitedHeaderNotifications),
  blockedScroll: createSelector(appSelector, (state) => state.blockedScroll),
  cookiesConsent: createSelector(appSelector, (state) => state.cookiesConsent),
};
